import { render, staticRenderFns } from "./IntroTeamPage.vue?vue&type=template&id=a5c6fa62&scoped=true&"
import script from "./IntroTeamPage.vue?vue&type=script&lang=js&"
export * from "./IntroTeamPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroTeamPage.vue?vue&type=style&index=0&id=a5c6fa62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6fa62",
  null
  
)

export default component.exports